import React from 'react';
import { motion } from 'framer-motion';

const AnimatedBrazilBackground = ({ style }) => (
  <>
    {/* Top-left accent */}
    <motion.svg
      width="180" height="180" viewBox="0 0 180 180"
      style={{ position: 'absolute', top: -48, left: -48, zIndex: 0, ...style }}
      initial={{ opacity: 0, scale: 0.85, rotate: -10 }}
      animate={{ opacity: 0.22, scale: 1, rotate: 0 }}
      transition={{ duration: 1.8, delay: 0.2 }}
      aria-hidden="true"
    >
      <ellipse cx="90" cy="90" rx="80" ry="60" fill="#14B88D" fillOpacity="0.18" />
      <ellipse cx="90" cy="90" rx="60" ry="40" fill="#F5C84C" fillOpacity="0.13" />
      <ellipse cx="90" cy="90" rx="40" ry="20" fill="#fff" fillOpacity="0.08" />
    </motion.svg>
    {/* Bottom-right accent */}
    <motion.svg
      width="220" height="160" viewBox="0 0 220 160"
      style={{ position: 'absolute', bottom: -56, right: -56, zIndex: 0, ...style }}
      initial={{ opacity: 0, scale: 0.85, rotate: 10 }}
      animate={{ opacity: 0.18, scale: 1, rotate: 0 }}
      transition={{ duration: 2.1, delay: 0.5 }}
      aria-hidden="true"
    >
      <ellipse cx="110" cy="80" rx="100" ry="60" fill="#14B88D" fillOpacity="0.13" />
      <ellipse cx="110" cy="80" rx="70" ry="35" fill="#F5C84C" fillOpacity="0.10" />
      <ellipse cx="110" cy="80" rx="40" ry="18" fill="#fff" fillOpacity="0.07" />
    </motion.svg>
  </>
);

export default AnimatedBrazilBackground;
